import { NotificationAlertOverride } from ".";
import { NotificationHandleType } from "../../Notifications";
import {
  createRequirementAction,
  createRequirementChildren,
  createRequirementTitle
} from "./helper";

export const RequirementsReRequestedPayee: NotificationAlertOverride = (
  notification,
  history
) => {
  return {
    theme: "warning",
    icon: "alert",
    title: createRequirementTitle(
      notification,
      NotificationHandleType.RequirementsReRequestedPayee
    ),
    children: createRequirementChildren(
      notification,
      NotificationHandleType.RequirementsReRequestedPayee
    ),
    action: createRequirementAction(notification, history)
  };
};
